<script lang="ts">
  import EmbedInterop from "./interop/EmbedInterop"
  import modalCloseOnEscape from "./interop/closeOnEscape"
  import modalFocusTrap from "./interop/focusTrap"

  let container: HTMLElement

  const modalCloseId = "aiden-close-button"

  export let advisorId: string

  const sendBackgroundClick = (event: KeyboardEvent | MouseEvent) => {
    const target = event.target as Element
    if (container === target || target.id === modalCloseId) {
      event.stopPropagation()
      EmbedInterop.sendBackgroundClickEvent(advisorId)
    }
  }

  $: modalCloseOnEscape(modalCloseId)
  $: modalFocusTrap(container)
</script>

<div
  aria-labelledby="page-title"
  aria-modal="true"
  role="dialog"
  tabindex="-1"
  bind:this={container}
  on:click={sendBackgroundClick}
>
  <slot />
</div>

<style>
  div {
    padding: 0.5rem 0.5rem;
    min-height: 100vh;
    box-sizing: border-box;
  }

  @media screen and (min-width: 74rem) {
    div {
      padding: 4.5rem 0.5rem;
    }
  }
</style>
